import React from "react";
import {useTranslation} from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "materialDashboard/components/MDInput";



const AspectsAutocomplete = ({ selectedAspects, setSelectedAspects, fieldProps={}, ...props }) => {
    const {t} = useTranslation(["inputs", "enums"]);


    const ASPECTS = [
        {id: "NORTH", label: t("enums:aspect.NORTH")},
        {id: "NORTH_EAST", label: t("enums:aspect.NORTH_EAST")},
        {id: "EAST", label: t("enums:aspect.EAST")},
        {id: "SOUTH_EAST", label: t("enums:aspect.SOUTH_EAST")},
        {id: "SOUTH", label: t("enums:aspect.SOUTH")},
        {id: "SOUTH_WEST", label: t("enums:aspect.SOUTH_WEST")},
        {id: "WEST", label: t("enums:aspect.WEST")},
        {id: "NORTH_WEST", label: t("enums:aspect.NORTH_WEST")},
    ];

    return (
        <Autocomplete
            multiple
            id="aspects-autocomplete"
            options={ASPECTS}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.label}
            value={ASPECTS.filter(a => selectedAspects?.includes(a.id))}
            onChange={(e, value) => setSelectedAspects(value.map(v => v.id))}
            renderInput={(params) => (
                <MDInput {...params}
                         variant="standard"
                         label={t('aspectsAutocomplete.label', 'Esposizione')}
                         placeholder={t('aspectsAutocomplete.placeholder', 'Seleziona esposizione')}
                         {...fieldProps}
                />
            )}
            {...props}
        />
    );
}

export default AspectsAutocomplete;
